import { TableEdges } from "canvas/edges-map";
import { DiagramElements } from "canvas/elements";
import { RowBlank } from "canvas/row/blank/blank";
import { ROW_HEIGHT } from "canvas/row/geometry";
import { TABLE_BODY_WIDTH, TABLE_CLIENT_WIDTH } from "canvas/table/geometry";
import { groupTableRows } from "canvas/table/rows";
import { EditRow, EditTable } from "diagram/model/edit/edit";
import * as React from "react";

interface Props {
    table: EditTable;
    tableEdges: TableEdges | null;
    elements: DiagramElements;
}

const getItemKey = (item: EditRow | EditRow[]): number =>
    Array.isArray(item) ? item[0].id : item.id;

/** Off-viewport placeholder: minimal DOM, layout size preserved for edges. */
export const TableInvisible = (props: Props) => {
    const [rows] = groupTableRows(props.table, props.tableEdges);
    const getToCount = (row: EditRow): number =>
        props.tableEdges?.get(row.id)?.to.length ?? 0;
    return (
        <div
            className={["bg-[var(--diagram-table-bg)] rounded-md"].join(" ")}
            style={{ width: TABLE_CLIENT_WIDTH + 2, padding: "0 1px" }}
        >
            <div
                className={[
                    "p-2 relative diagram-table-title rounded-t-md",
                    "text-[var(--diagram-table-text)]",
                ].join(" ")}
            >
                <div
                    className={[
                        "transition-transform text-center font-semibold flex-0",
                    ].join(" ")}
                    style={{ width: TABLE_BODY_WIDTH }}
                >
                    <div
                        className={
                            "leading-normal break-words whitespace-pre-wrap"
                        }
                    >
                        {props.table.value.name}
                    </div>
                </div>
            </div>
            {rows.map((item) =>
                Array.isArray(item) ? (
                    <div key={item[0].id} style={{ height: ROW_HEIGHT }} />
                ) : (
                    <RowBlank
                        key={getItemKey(item)}
                        row={item}
                        edgesToCount={getToCount(item)}
                        elements={props.elements}
                        tableId={props.table.id}
                    />
                )
            )}
            <div style={{ height: 13 }} />
        </div>
    );
};
